<template>
  <div class="content main" v-if="articleDetail.id!=''">
    <div class="crumbs flexHC">
      <div class="item" v-for="(categoryName, index) in articleDetail.articleCategoryNames" :key="articleDetail.articleCategoryIds[index]">
        <span style="cursor: pointer;" @click="goToArticleList(articleDetail.articleCategoryIds[index])">{{categoryName}}</span>
        <span v-if="index<articleDetail.articleCategoryNames.length">></span>
      </div>
    </div>
    <div class="article">
      <p class="article-title">{{articleDetail.articleTitle}}</p>
      <div class="time-box">
        <span class="time">发布时间：{{articleDetail.releaseTime}}</span>
        <span class="source">来源：{{articleDetail.articleOrigin}}</span>
      </div>
      <!-- 后台富文本区域 -->
      <div>
        <div class="editor-content-view" v-html="articleDetail.content">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetail } from "@/api/article";

export default {
  data() {
    return {
      articleDetail: {},
      articleId: 0,
      articleListUrl: '/list'
    }
  },
  watch: {
    articleId(){
      this.getArticleDetail()
    }
  },
  methods: {
    // 查询文章详情
    getArticleDetail(){
      const _t = this
      getDetail({
        id: _t.articleId
      }).then((result)=>{
        if(result.status === 'OK'){
          _t.articleDetail = result.data
        }
      })
    },
    // 去列表
    goToArticleList(categoryId){
      if(parseInt(this.articleDetail.articleCategoryIds[0]) == categoryId){
        this.$router.push({
          path: this.articleListUrl,
          query: {
            parentId: this.articleDetail.articleCategoryIds[0]
          }
        })
      }else if(parseInt(this.articleDetail.articleCategoryIds[1]) == categoryId){
        this.$router.push({
          path: this.articleListUrl,
          query: {
            parentId: this.articleDetail.articleCategoryIds[0],
            categoryId: this.articleDetail.articleCategoryIds[1]
          }
        })
      }
    }
  },
  created() {
    this.articleId = this.$route.query.id
  }
}
</script>
<style lang="less" scoped>
.content {
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
  margin-top: 25px;
  margin-bottom: 80px;
  padding: 30px;
}

.crumbs {
  padding-bottom: 20px;
  border-bottom: 1px solid #F8F8FB;
  div:first-child {
    span {
      &:first-child {
        &::after {
          content: '';
          width: 100%;
          height: 2px;
          background: #0D53BC;
          position: absolute;
          bottom: -20px;
          left: 0;
        }
      }
    }
  }
  div:last-child {
    span {
      color: #1B252C;
      &:last-child {
        display: none;
      }
    }
  }
  span {
    position: relative;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #909097;
    line-height: 33px;
  }
}


.article {
  .article-title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1B252C;
    line-height: 33px;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 16px;
  }
  .time-box {
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #5F5F6A;
    line-height: 28px;
    margin-bottom: 30px;
    .time {
      margin-right: 240px;
    }
  }

  /*/deep/ p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f5f6a;
    line-height: 28px;
  }

  /deep/ img {
    margin: 20px 0;
  }*/

}
</style>
<style scoped src="./../style/wangeditor.css?v=1" />
